import $ from 'jquery';

var updateSlug = function updateSlug(element, isPrizeSlug) {
  var slugInput = element.parents('.content').find('[name*="[slug]"]');
  var loadableParent = slugInput.parents('.field.loadable');

  if (slugInput.attr('readonly') === 'readonly' || element.val() === '') {
    return;
  }

  loadableParent.addClass('loading');

  const data = isPrizeSlug
    ? {
        name: element.val(),
        id: $('#app_prize_category_parent').val(),
        locale: element.parents('div[data-locale]').data('locale'),
      }
    : {
        name: element.val(),
      };

  $.ajax({
    type: 'GET',
    url: slugInput.attr('data-url'),
    data,
    dataType: 'json',
    accept: 'application/json',
    success(response) {
      slugInput.val(response.slug);
      if (slugInput.parents('.field').hasClass('error')) {
        slugInput.parents('.field').removeClass('error');
        slugInput.parents('.field').find('.sylius-validation-error').remove();
      }
      loadableParent.removeClass('loading');
    },
  });
};

var toggleSlugModification = function toggleSlugModification(button, slugInput) {
  if (slugInput.attr('readonly')) {
    slugInput.removeAttr('readonly');
    button.html('<i class="unlock icon"></i>');
  } else {
    slugInput.attr('readonly', 'readonly');
    button.html('<i class="lock icon"></i>');
  }
};

$.fn.extend({
  productSlugGenerator() {
    var timeout;

    $('[name*="sylius_product[translations]"][name*="[name]"]').on('input', function (event) {
      clearTimeout(timeout);
      const element = $(event.currentTarget);

      timeout = setTimeout(function () {
        updateSlug(element);
      }, 1000);
    });

    $('.js__slug-input input').on('focusin focusout', function (event) {
      event.preventDefault();
      toggleSlugModification($(event.currentTarget).next('.toggle-taxon-slug-modification'), $(event.currentTarget));
    });
  },
});

$.fn.extend({
  prizeCategorySlugGenerator() {
    var timeout;

    $('[name*="app_prize_category[translations]"][name*="[title]"]').on('input', function (event) {
      clearTimeout(timeout);
      const element = $(event.currentTarget);
      const isPrizeSlug = true;
      timeout = setTimeout(function () {
        updateSlug(element, isPrizeSlug);
      }, 1000);
    });

    $('.js__slug-input input').on('focusin focusout', function (event) {
      event.preventDefault();
      toggleSlugModification($(event.currentTarget).next('.toggle-taxon-slug-modification'), $(event.currentTarget));
    });
  },
});

$.fn.extend({
  prizeSlugGenerator() {
    var timeout;
    $('[name*="app_prize[translations]"][name*="[title]"]').on('input', function (event) {
      clearTimeout(timeout);
      const element = $(event.currentTarget);

      timeout = setTimeout(function () {
        updateSlug(element);
      }, 1000);
    });

    $('.js__slug-input input').on('focusin focusout', function (event) {
      event.preventDefault();
      toggleSlugModification($(event.currentTarget).next('.toggle-taxon-slug-modification'), $(event.currentTarget));
    });
  },
});

$.fn.extend({
  campaignSlugGenerator() {
    var timeout;
    $('[name*="app_campaign[translations]"][name*="[title]"]').on('input', function (event) {
      clearTimeout(timeout);
      const element = $(event.currentTarget);

      timeout = setTimeout(function () {
        updateSlug(element);
      }, 1000);
    });

    $('.js__slug-input input').on('focusin focusout', function (event) {
      event.preventDefault();
      toggleSlugModification($(event.currentTarget).next('.toggle-taxon-slug-modification'), $(event.currentTarget));
    });
  },
});

$.fn.extend({
  qureIssueSlugGenerator() {
    let timeout;

    $('[name*="issue[translations]"][name*="[title]"]').on('input', event => {
      clearTimeout(timeout);
      const element = $(event.currentTarget);

      timeout = setTimeout(() => {
        updateSlug(element);
      }, 1000);
    });

    const $slugInput = $('.js__slug-input input');

    $slugInput.on('focusin', event => {
      event.preventDefault();
      const $currentTarget = $(event.currentTarget);
      if ($currentTarget.attr('readonly')) {
        toggleSlugModification($currentTarget.next('.toggle-qure-issue-slug-modification'), $currentTarget);
      }
    });

    $slugInput.on('focusout', event => {
      event.preventDefault();
      const $currentTarget = $(event.currentTarget);
      if (!$currentTarget.attr('readonly')) {
        toggleSlugModification($currentTarget.next('.toggle-qure-issue-slug-modification'), $currentTarget);
      }
    });

    $('.toggle-qure-issue-slug-modification').on('click', event => {
      event.preventDefault();
      toggleSlugModification($(event.currentTarget), $(event.currentTarget).siblings('input'));
    });
  },
});

$.fn.extend({
  citySlugGenerator() {
    let timeout;

    $('[name*="city[translations]"][name*="[name]"]').on('input', event => {
      clearTimeout(timeout);
      const element = $(event.currentTarget);

      timeout = setTimeout(() => {
        updateSlug(element);
      }, 1000);
    });

    const $slugInput = $('.js__slug-input input');

    $slugInput.on('focusin', event => {
      event.preventDefault();
      const $currentTarget = $(event.currentTarget);
      if ($currentTarget.attr('readonly')) {
        toggleSlugModification($currentTarget.next('.toggle-city-slug-modification'), $currentTarget);
      }
    });

    $slugInput.on('focusout', event => {
      event.preventDefault();
      const $currentTarget = $(event.currentTarget);
      if (!$currentTarget.attr('readonly')) {
        toggleSlugModification($currentTarget.next('.toggle-city-slug-modification'), $currentTarget);
      }
    });

    $('.toggle-city-slug-modification').on('click', event => {
      event.preventDefault();
      toggleSlugModification($(event.currentTarget), $(event.currentTarget).siblings('input'));
    });
  },
});
